import { BrowseCharactersLayout } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.characters";

export default function BrowseCharactersLayoutRoute() {
  return <BrowseCharactersLayout />;
}
